import countries from "../../assets/countries.json";

export const getCountryName = (code: string) => {
  return countries.find((c) => code === c.value)?.label || "";
};
